// external libs
import { ofType } from 'redux-observable'
import { from, of } from 'rxjs'
import { switchMap, catchError } from 'rxjs/operators'
import Api from '../Services/SuriApi'

// redux
import GeneralActions, { GeneralTypes } from '../Redux/GeneralRedux'

const GetBeApiDataEpic = action$ =>
  action$.pipe(
    ofType(GeneralTypes.ON_SEND_CALLBACK_REQUEST),
    switchMap(action =>
      from(Api.sendCallbackRequest(action.data)).pipe(
        switchMap(response =>
          from([
            GeneralActions.onSendCallbackRequestSuccess(response.data, action.callbackType),
            GeneralActions.toggleConfirmModal(true)
          ])
        ),
        catchError(() => of(GeneralActions.onStopFetching())
        )
      )
    )
  )

export default GetBeApiDataEpic
